import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '../../lib/styles';

const useStyles = makeStyles(theme => {
  return {
    root: {
      '&.MuiChip-root': {
        backgroundColor: '#E2E6FF',
        color: theme.palette.primary.dark,
        height: 28,
        borderRadius: 4,
      },
      '& svg': {
        width: 12,
        height: 12,
        color: theme.palette.primary.main,
        marginRight: 8,
        '&:hover': {
          color: theme.palette.primary.dark,
        },
      },
    },
  };
});

const SelectChip = forwardRef(function SelectChip(props, ref) {
  const { label, onDelete, ...restProps } = props;
  const classes = useStyles();
  return <Chip classes={classes} label={label} onDelete={onDelete} ref={ref} {...restProps} />;
});

SelectChip.propTypes = {
  className: Proptypes.string,
  onDelete: Proptypes.func.isRequired,
  label: Proptypes.string.isRequired,
  deleteIcon: Proptypes.node,
};

SelectChip.defaultProps = {
  className: null,
  deleteIcon: <CloseIcon fontSize="small" />,
};

SelectChip.displayName = 'SelectChip';

export default SelectChip;
